import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "indexlayout" }
const _hoisted_2 = { class: "indexlayout-right-main" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_left = _resolveComponent("left")!
  const _component_right_top = _resolveComponent("right-top")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_permission = _resolveComponent("permission")!
  const _component_right_footer = _resolveComponent("right-footer")!
  const _component_attestation = _resolveComponent("attestation")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_left, {
      collapsed: _ctx.collapsed,
      topNavEnable: _ctx.topNavEnable,
      belongTopMenu: _ctx.belongTopMenu,
      selectedKeys: _ctx.selectedKeys,
      openKeys: _ctx.leftOpenKeys,
      menuData: _ctx.permissionMenuData,
      onOpenChange: _ctx.onOpenChange
    }, null, 8, ["collapsed", "topNavEnable", "belongTopMenu", "selectedKeys", "openKeys", "menuData", "onOpenChange"]),
    _createElementVNode("div", {
      id: "indexlayout-right",
      class: _normalizeClass({ 'fiexd-header': _ctx.headFixed })
    }, [
      _createVNode(_component_right_top, {
        collapsed: _ctx.collapsed,
        tabNavEnable: _ctx.tabNavEnable,
        topNavEnable: _ctx.topNavEnable,
        belongTopMenu: _ctx.belongTopMenu,
        toggleCollapsed: _ctx.toggleCollapsed,
        breadCrumbs: _ctx.breadCrumbs,
        menuData: _ctx.permissionMenuData,
        routeItem: _ctx.routeItem
      }, null, 8, ["collapsed", "tabNavEnable", "topNavEnable", "belongTopMenu", "toggleCollapsed", "breadCrumbs", "menuData", "routeItem"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_permission, {
          roles: _ctx.routeItem.roles,
          style: {"flex":"1"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_router_view, { style: {"height":"100%"} })
          ]),
          _: 1
        }, 8, ["roles"]),
        true
          ? (_openBlock(), _createBlock(_component_right_footer, { key: 0 }))
          : _createCommentVNode("", true)
      ])
    ], 2),
    (
        (_ctx.certStatus == 0 ||
        _ctx.certStatus == 1 ||
        _ctx.certStatus == 2 ||
        _ctx.certStatus == 4 ||
        _ctx.certStatus == 5 ||
        _ctx.contStatus == 1 ||
        _ctx.contStatus == 4 ||
        _ctx.contStatus == 5)&&_ctx.oneShow==='one'
      )
      ? (_openBlock(), _createBlock(_component_attestation, {
          key: 0,
          certStatus: _ctx.certStatus,
          contStatus: _ctx.contStatus
        }, null, 8, ["certStatus", "contStatus"]))
      : _createCommentVNode("", true)
  ]))
}